import { css } from "styled-components";
import styled from "styled-components";
import FlexBox from "../../../FlexBox/FlexBox";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";
import { MobileOperatingSystem } from "../../../../Utils/getMobileOperatingSystem";

interface IStickyBackgroundProps {
  $os: MobileOperatingSystem;
}

const _LandingHighlighProductContainer = styled(FlexBox)`
  display: flex;
  flex-direction: column;
  height: 100%;

  @media ${responsiveMap.maxLg} {
    text-align: center;
  }

  /* top content */
  .highlight-product-adrien-cachot-top-content {
    width: 100%;
    max-width: 286px;
    position: absolute;
    top: 0;
    left: 0;
    @media ${responsiveMap.maxLg} {
      position: relative;
    }
  }

  /* bottom content */
  .highlight-product-adrien-cachot-bottom-content {
    justify-content: flex-end;
    padding-right: 0;
    margin-top: auto;

    @media (${responsiveMap.maxLg}) {
      justify-content: flex-start;
      margin-top: 74vw;
    }
  }
  .highlight-product-adrien-cachot-bottom-content-wrapper {
    width: 100%;
    max-width: 325px;
  }
`;

export const _LandingHighlighProductCoverContainer = styled(FlexBox)<
  {
    $bg?: {
      desktop?: string;
      mobile?: string;
    };
  } & IStickyBackgroundProps
>(({ $bg, $os }) => {
  const { desktop: desktopBg, mobile: mobileBg } = $bg || {};
  return css`
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh; /* Fallback */
    height: -webkit-fill-available;
    height: ${$os === "iOS" ? "100vh" : "100dvh"};
    padding-top: 64px;
    background-image: url(${desktopBg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 1;
    display: flex;
    justify-content: center;

    @media ${responsiveMap.maxLg} {
      background-image: url(${mobileBg || desktopBg});
      padding-bottom: 164px;
    }
  `;
});

const _LandingHighlighProductAdrienCachotRoot = styled("section")<
  {
    $bg?: {
      desktop?: string;
      mobile?: string;
      color?: string;
    };
  } & IStickyBackgroundProps
>(({}) => {
  return css`
    position: relative;
    min-height: 808px;
    width: 100%;
    aspect-ratio: 1440 / 808;
    background-color: #000;
    @media ${responsiveMap.maxLg} {
      aspect-ratio: unset;
    }
  `;
});

export const _LandingHighlighProductContentContainer = styled(
  FlexBox
)<IStickyBackgroundProps>(({ $os }) => {
  return css`
    position: relative;
    padding: 102px 48px 96px;
    height: 100%;
    display: flex;
    flex-direction: column;
    z-index: 2;

    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    @media ${responsiveMap.maxLg} {
      padding: 112px 24px 92px;
    }
  `;
});

export const _FakeContentContainer = styled(FlexBox)`
  /* height: 100vh;  */
  /* height: -webkit-fill-available; */
  /* height: 100dvh; */
`;

export const _HighlightProductAdrienCachotCoverContainerWrapper = styled(
  "div"
)<IStickyBackgroundProps>(({ $os }) => {
  return css`
    transform: translateY(-100%);

    /* max-height: 100vh; */
    /* max-height: -webkit-fill-available; */
    /* max-height: ${$os === "iOS" ? "100vh" : "100dvh"}; */

    @media ${responsiveMap.maxLg} {
      /* height: calc(100vh); */
      /* transform: translateY(-100vh); */
    }
  `;
});

export const _StickyBackground = styled("div")<IStickyBackgroundProps>(
  ({ $os }) => {
    return css`
      position: sticky;
      top: 0;
      overflow: hidden;
      /* height: 100vh;  */
      /* height: -webkit-fill-available; */
      /* height: ${$os === "iOS" ? "100vh" : "100dvh"}; */

      @media ${responsiveMap.maxLg} {
        /* height: calc(100vh - 64px); */

        .highlight-product-adrien-cachot-background {
          transition: transform 1s ease-in-out;
          transform: scale(1.5);
        }
        .highlight-product-adrien-cachot-cover-container-wrapper {
          transform: translateY(0);
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          transition: transform 0.6s ease-in-out;
        }

        .highlight-product-adrien-cachot-container {
          transition: opacity 1s ease-in-out;
          opacity: 0;
        }

        &.up {
          .highlight-product-adrien-cachot-cover-container-wrapper {
            /* transform: translateY(-100vh); */
          }
          .highlight-product-adrien-cachot-background {
            transform: scale(1);
          }
          .highlight-product-adrien-cachot-container {
            opacity: 1;
          }
        }
      }
    `;
  }
);

export {
  _LandingHighlighProductAdrienCachotRoot,
  _LandingHighlighProductContainer,
};
